// extracted by mini-css-extract-plugin
export default {"loggedInRoutesWrapper":"login-routes_loggedInRoutesWrapper__YHZqJ","mainPage":"login-routes_mainPage__Vmo8B"};